import { ShieldCheck } from "lucide-react";

export default function IdVerifiedBadge({ client, testid, showUnverified = false }) {
  if (client?.voi_status === "APPROVED") {
    const when = client.voi_verified_at ? new Date(client.voi_verified_at).toLocaleDateString() : "";
    return (
      <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-medium px-1.5 py-0.5 rounded-full"
            style={{ color: "#fff", background: "var(--moss)" }} title={`Identity verified${when ? ` ${when}` : ""}`}
            data-testid={testid}>
        <ShieldCheck size={10} /> ID verified
      </span>
    );
  }
  if (!showUnverified) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-[var(--ink-3)]" data-testid={testid}>
      <ShieldCheck size={10} /> ID not verified
    </span>
  );
}
